"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _image = _interopRequireDefault(require("../image"));

var _label = _interopRequireDefault(require("../label"));

var _context = require("../../context");

var _tokens = require("../../../tokens");

var _versions = require("../../_utils/versions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  color: ", ";\n  border: ", ";\n  border-radius: 50%;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  margin-right: ", ";\n\n  img {\n    height: 100%;\n    user-select: none;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\npadding-top: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: -webkit-box;\n  align-items: center;\n  justify-content: start;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getInitialsFromName = function getInitialsFromName(name) {
  var initials = name.match(/\b\w/g) || [];
  initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
  return initials;
};

var getDefaultColors = function getDefaultColors(props) {
  var color = (0, _versions.getColor)(props, 'avatar');
  return {
    backgroundColor: color.background,
    color: color.text,
    border: color.border
  };
}; // const defaultColorAvatar = {
//   backgroundColor: colors.avatar.background,
//   color: colors.avatar.text,
//   border: colors.avatar.border
// }


var getColors = function getColors(props) {
  var defaultColors = getDefaultColors(props);
  var colors = props.colors;

  if (colors) {
    return {
      color: colors.text || defaultColors.color,
      backgroundColor: colors.background || defaultColors.backgroundColor,
      border: '1px solid ' + (colors.border || defaultColors.border)
    };
  }

  return {
    color: defaultColors.color,
    backgroundColor: defaultColors.backgroundColor,
    border: defaultColors.border
  };
};

var sizes = {
  small: _tokens.misc.avatar.small,
  medium: _tokens.misc.avatar.medium,
  large: _tokens.misc.avatar.large
};

var Avatar = function Avatar(props) {
  if (props.name && props.image) {
    return _react["default"].createElement(Avatar.Content, null, _react["default"].createElement(AvatarElement, props, _react["default"].createElement(_image["default"], {
      source: props.image
    })), props.displayName && _react["default"].createElement(Avatar.Name, props, _react["default"].createElement("div", null, props.name), props.secondaryName && _react["default"].createElement("div", null, _react["default"].createElement(_label["default"], {
      color: 'atomic',
      type: "assistive"
    }, props.secondaryName))));
  } else if (props.name && !props.image) {
    return _react["default"].createElement(Avatar.Content, null, _react["default"].createElement(AvatarElement, props, getInitialsFromName(props.name)), props.displayName && _react["default"].createElement(Avatar.Name, props, _react["default"].createElement("div", null, props.name), props.secondaryName && _react["default"].createElement("div", null, _react["default"].createElement(_label["default"], {
      color: 'atomic',
      type: "assistive"
    }, props.secondaryName))));
  } else {
    return _react["default"].createElement(AvatarElement, props, _react["default"].createElement(_image["default"], {
      source: props.image
    }));
  }
};

Avatar.Content = _styledComponents["default"].div(_templateObject());

var AvatarElement = function AvatarElement(props) {
  return (// <Consumer>
    //   {({ version }) => <Avatar.Element {...props} version={version} />}
    // </Consumer>
    _react["default"].createElement(Avatar.Element, props)
  );
};

Avatar.Name = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.secondaryName ? _tokens.spacing.small : null;
});
Avatar.Element = _styledComponents["default"].div(_templateObject3(), function (props) {
  return sizes[props.size];
}, function (props) {
  return sizes[props.size];
}, function (props) {
  return getColors(props).backgroundColor;
}, function (props) {
  return getColors(props).color;
}, function (props) {
  return getColors(props).border;
}, function (props) {
  return props.name ? _tokens.spacing.xsmall : null;
});
Avatar.propTypes = {
  /** Avatar size */
  size: _propTypes["default"].oneOf(['small', 'medium', 'large']),

  /** Avatar image */
  image: _propTypes["default"].string,

  /** User's name */
  name: _propTypes["default"].string,

  /** Show or Hide name */
  displayName: _propTypes["default"].bool
};
Avatar.defaultProps = {
  size: 'medium',
  image: null,
  name: null,
  displayName: true
};
Avatar.displayName = 'Avatar';

var _default = (0, _context.withVersion)(Avatar);

exports["default"] = _default;